import { WbTable } from '@agilelab/plugin-wb-platform';
import { TableBody } from '@material-ui/core';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { Test } from '../types';
import { TaskDrawer } from './TaskDrawer/TaskDrawer';
import { TestHistoryEmptyState } from './TestHistoryEmptyState';
import { TestTableLoader } from './TestTableLoader';
import { TestTableRow } from './TestTableRow';

export function TestHistory() {
  const {
    testsState,
    testPagination,
    tests,
    onTestPageChange,
    onTestChangeRowsPerPage,
    selectedTask,
    setSelectedTask,
    monacoEditorRef,
  } = useEditorPageContext();

  if (!tests.length) return <TestHistoryEmptyState />;

  return (
    <>
      <WbTable<Test>
        stickyHeader
        tableStyles={{ tableLayout: 'auto' }}
        components={{
          tableLoader: {
            loading: testsState.loading,
            loader: <TestTableLoader rows={5} />,
          },
          tableContent: {
            columns: [
              {
                field: 'id',
                maxWidth: 10,
                resizable: false,
              },
              {
                headerName: 'Status',
                field: 'status',
                maxWidth: 10,
                resizable: false,
              },
              {
                headerName: 'ID / Date',
                field: 'startDate',
              },
              {
                uniqueFieldId: 'results',
                headerName: 'Results',
              },
            ],
            body: (
              <TableBody>
                {tests.map((t, i) => (
                  <TestTableRow key={i} test={t} />
                ))}
              </TableBody>
            ),
          },
        }}
        pagination={{
          rowsPerPageOptions: [5, 10, 25],
          count: testsState.value?.page?.count || 0,
          limit: testPagination.limit,
          offset: testPagination.offset,
          onPageChange: onTestPageChange,
          onRowsPerPageChange: onTestChangeRowsPerPage,
        }}
        styles={{
          container: { height: '100%', flex: '1 1 0' },
        }}
      />

      <TaskDrawer
        task={selectedTask}
        open={Boolean(selectedTask)}
        onClose={() => {
          setSelectedTask(null);
          monacoEditorRef.current?.applyDecorations(
            undefined,
            undefined,
            'white',
          );
        }}
      />
    </>
  );
}
